export default "__VITE_ASSET__Bp0p9$Tp__"